"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeedbackIcon;
var _greenCheckIcon = _interopRequireDefault(require("../assets/green-check-icon.png"));
var _redXIcon = _interopRequireDefault(require("../assets/red-x-icon.png"));
var _react = _interopRequireDefault(require("react"));
require("./FeedbackIcon.css");
function FeedbackIcon(_ref) {
  var correct = _ref.correct,
    iconSize = _ref.iconSize;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "task-passage-click-feedback-icon ".concat(correct ? "correct" : "incorrect")
  }, correct ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: iconSize,
      height: iconSize
    },
    alt: "green checkmark icon",
    src: _greenCheckIcon.default
  }) : /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: iconSize,
      height: iconSize
    },
    alt: "red x icon",
    src: _redXIcon.default
  }));
}